<template>
    <div>Template da definire</div>
</template>

<script>
    import router from "../../router/router";

    export default {
        name: "BaseForm",
        router,
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            this.toTop();

        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        beforeRouteLeave(to, from, next) {
            this.do_update()
            next()
        },
        beforeRouteUpdate(to, from, next) {
            // Aggiorno lo store in modo che tenga conto delle modifiche che stavo facendo e se torno indietro me le mantenga
            this.do_update()


            // Se sono ancora io faccio l'update from store?
            if (from.name === to.name) {
                this.updateFromStore(to.params.id)
            }
            // Passo al prossimo elemento
            next()
        },
        data() {
            return {
                step: -1,
                id_form: null,
                scrolling: null,
                nextScroll: null
            }
        },
        methods: {
            do_update() {
                if (this.id_form === null || this.id_form < 0) return true
                if (this.$store.getters.get_by_id(this.id_form)) {
                    this.$store.dispatch({
                        type: 'update',
                        data: this.form,
                        id_form: this.id_form,
                    })
                }

            }, updateFromStore() {

            },
            focusNext(submit) {
                if (submit) this.submit(this.getData());
            },
            focusStep(event) {
                let step = event.currentTarget;
                if (!step.classList.contains('active')) {
                    this.center(step);
                }
            },
            focusField(div) {
                let inps = div.querySelectorAll('input');
                for (let i = 0; i < inps.length; i++) {
                    // Verifico se ha un vv-validate
                    let inp = inps[i]
                    if (inp.dataset.vvName) {
                        if (!this.compiled(inp.dataset.vvName)) {
                            inp.focus()
                            return
                        }
                    } else {
                        if (inp.value === '') {
                            inp.focus()
                            return;
                        }
                    }
                }
                if (inps[0])
                    inps[0].focus()
            },
            next() {
                // Verifico se mi hanno passato qualche parametro
                let allOk = true
                for (let i = 0; i < arguments.length; i++) {
                    let arg = arguments[i]
                    if (arg instanceof Object !== false) continue // Potrebbe essere 'event' l'argomento
                    if (typeof arg === typeof true) {
                        if (!arg) allOk = false  // Potrei avergli passato un boolean
                    }
                    if (!this.compiled(arg)) allOk = false
                    if (!allOk) break;
                }
                if (!allOk) {
                    let step = this.$el.querySelector('.v-step.active')
                    return this.focusField(step)
                }

                let steps = this.$el.querySelectorAll('.v-step')
                for (let i = this.step + 1; i < steps.length; i++) {
                    let div = steps[i];
                    if (this.isVisible(div)) {
                        this.center(div)
                        return true
                    }
                }
                console.log('step missing?')
            }, center(div) {
                // Estraggo le info su quanto è grande questo div
                let altDiv = div.clientHeight;
                // Su quanto è il viewort
                let dimSchermo = window.innerHeight;
                // A questo punto posso sapere quanto spazio lasciare sopra per centrarlo precisamente
                let offset = (dimSchermo - altDiv) / 2;
                // console.log('altezza div', altDiv);
                // console.log('dim schermo', dimSchermo);
                // console.log('offset', offset);

                this.scrollTo(div, offset)


                // Eseguo il focus sul primo input che trovo in questo div
                this.focusField(div)
            }, scrollTo(div, offset) {
                if (offset < 0) offset *= -1

                if (this.scrolling) {
                    this.nextScroll = {div: div, offset: -1 * offset}
                    return
                }
                this.scrolling = true
                this.$scrollTo(div, 300, {
                    offset: -1 * offset, easing: 'linear', onDone: () => {
                        if (this.nextScroll != null) {
                            let next = this.nextScroll
                            this.nextScroll = null
                            this.scrolling = false
                            this.scrollTo(next.div, next.offset)
                        }
                        else
                            this.scrolling = false
                    }, oncancel: () => {
                        this.scrolling = false;
                        this.nextScroll = null
                    }
                });

                // Se per qualche motivo non attiva oncancel o ondone in ogni caso segno che non sto più scrollando
                // per evitare che si 'inceppi'
                setTimeout(() => {
                    this.scrolling = false
                },2000)
            },
            toTop() {
                let steps = this.$el.querySelectorAll('.v-step')
                this.center(steps[0])
            }, submit() {
                console.log('Submit to define!');
            }, getData() {
                let data = {};
                for (let i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].value)
                        for (let j = 0; j < this.questions[i].value.length; j++) {
                            let dat = this.questions[i].value[j];
                            data[dat.name] = dat.value;
                        }
                }
                return data;
            }, checkUpdate() {
                console.log('update required');
            }, handleScroll() {
                // Estraggo tutti i miei child e verifico quale di questi è in "posizione" centrale
                let divs = this.$el.querySelectorAll('.v-step');

                // So quanto è il viewort, da qui calcolo la posizione centrale
                let center = window.innerHeight / 2;

                let i = 0;
                this.step = -1;

                let supportPageOffset = window.pageYOffset !== undefined;
                let isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                // Verifico di quanto siamo scrollati verticalmente
                let scrollY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;


                for (i = 0; i < divs.length; i++) {
                    let step = divs[i];
                    // Estraggo le info su quanto è grande questo div
                    let altDiv = step.clientHeight;
                    // Ottengo la posizione dell'elemento rispetto all'inizio della pagina
                    let pos = this.getPos(step);
                    if (pos === false) continue;

                    // La adeguo allo scroll attuale
                    pos -= scrollY

                    // Quindi posso calcolare la posizione di inizio/fine del div rispetto allo schermo visibile
                    let begin = pos
                    let end = pos + altDiv

                    // In questo caso una parte dell'elemento almeno è al centro dello schermo ( se lui è in parte al centro, nessun'altro può esserlo )
                    if ((begin < center) && (center < end)) {
                        this.step = i;
                        return;
                    }
                    // Se quantomeno è all'interno dello schermo.. in mancanza di meglio, scelgo questo
                    if (begin > 0) {
                        this.step = i;
                    }
                }

            }, getPos(node) {
                let curtop = 0;
                if (node.offsetParent) {
                    do {
                        curtop += node.offsetTop;
                        // eslint-disable-next-line
                    } while (node = node.offsetParent);
                    return curtop
                }
                return false;
            }, state(name) {
                let status = this.fields[name];
                if (!status) return null;
                if (status.pristine) return null;
                return status.valid;
            }, compiled() {
                for (let i = 0; i < arguments.length; i++) {
                    let field = arguments[i];
                    if (this.fields[field]) {
                        if (!this.fields[field].valid)
                            return false;
                    } else {
                        if (this.form[field] === null)
                            return false
                    }
                }
                return true;
            }, isVisible(div) {
                return div.offsetHeight > 0;
            }, data_format(value) {
                if (value === null) return ''

                value = this._applyAt(value, 2, '-');
                value = this._applyAt(value, 5, '-');
                return value;
            }, phone_format(value) {
                if (value === null) return ''

                // Verifico se le prime due cifre sono 00
                if (value.substr(0, 2) === '00') {
                    // 0039 -> +39 ...
                    value = '+' + value.substr(2);
                }

                if (value[0] === '+') {
                    //    3   7  11  14
                    // +39 327 000 00 00
                    value = this._applyAt(value, 3, ' ');
                    value = this._applyAt(value, 7, ' ');
                    value = this._applyAt(value, 11, ' ');
                    value = this._applyAt(value, 14, ' ');
                } else {
                    //    3  7  10
                    // 327 000 00 00
                    value = this._applyAt(value, 3, ' ');
                    value = this._applyAt(value, 7, ' ');
                    value = this._applyAt(value, 10, ' ');
                }

                return value;
            }, isNumeric(s) {
                return !isNaN(s - parseFloat(s));
            }, _applyAt(value, pos, divider) {
                let first = '';
                let last = '';

                if (value.length > pos) {
                    if (value[pos] !== divider) {
                        if (this.isNumeric(value[pos])) {
                            first = value.substr(0, pos);
                            last = value.substr(pos);
                            value = first + divider + last;
                        } else {
                            first = value.substr(0, pos);
                            last = value.substr(pos + 1);
                            value = first + divider + last;
                        }
                    }
                }
                return value;
            }, goTo(route) {
                this.$router.push({name: route, params: {id: 0}})
            }
        },computed: {
            partner_principale() {
                return this.$store.getters.partner_principale
            },partner_secondari() {
                return this.$store.getters.partner_secondari
            },thanksto() {
                return this.$store.getters.thanksto
            },race_logo() {
                return this.$store.getters.race_logo
            }, titolo() {
                return this.$store.getters.titolo_iniziale
            }, sottotitolo() {
                return this.$store.getters.sottotitolo_iniziale
            }, race_name() {
                return this.$store.getters.nome_race
            }, testo_competitivi() {
                return this.$store.getters.testo_competitivi
            }, testo_competitivi_rosa() {
                return this.$store.getters.testo_competitivi_rosa
            }, conMaglia() {
                return this.$store.getters.con_maglia
            }, testo_maglia() {
                return this.$store.getters.testo_maglia
            }, img_maglia() {
                return this.$store.getters.img_maglia
            }, competitivi() {
                return this.$store.getters.competitivi
            }
        }
    }
</script>

<style scoped>

</style>